import { UserTranslator } from 'src/translators'
import { useGetExternalUsersQuery } from 'src/types/generated'

export const useGetExternalUsers = () => {
  const { loading, data, error, refetch } = useGetExternalUsersQuery()

  return {
    loading,
    externalUsers:
      data && data.externalUsers ? UserTranslator.toExternalUserEntities(data.externalUsers) : [],
    error,
    refetch,
  }
}
